<template>
  <div class="signUp">
    <ProgressBarForSignUp :current-phase="currentPhase" :phase-list="PHASE_LIST" />
    <div class="singUpCard">
      <SendAuthCode
        v-show="currentPhase === PHASE_LIST.SEND_AUTH_CODE.number"
        class="sendAuthCode"
        @goto-next="gotoInputAuthCode"
      />
      <InputAuthCode
        v-show="currentPhase === PHASE_LIST.INPUT_AUTH_CODE.number"
        class="inputAuthCode"
        :mail-address="mailAddress"
        :error-get-mail-address="errorGetMailAddress"
        @goto-next="gotoInputUserData"
        @fix-email="fixEmail"
      />
      <InputUserData
        v-show="currentPhase === PHASE_LIST.INPUT_USER_DATA.number"
        class="inputUserData"
        :prev-page-type="prevPageType"
        :mail-address="mailAddress"
        :is-previous-page-action-complete="isPreviousPageActionComplete"
        :hash-key="hashKey"
        :action-user-info="actionUserInfo"
        @goto-next="gotoComplete"
      />
      <Complete v-show="currentPhase === PHASE_LIST.COMPLETE.number" class="complete" :prev-page-type="prevPageType" />

      <!-- メルマガパーミッション更新失敗 -->
      <Error
        :is-open="isOpenMailPermissionFailedDialog"
        :title="'パーミッションの更新に失敗しました。'"
        :detail-error-list="['一部の会員情報更新に失敗しました。プロフィール画面から再度お試しください。']"
        persistent
        :button-custom-text="'閉じる'"
        @click-dialog-button="closeDialog"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import ProgressBarForSignUp from '../common/ProgressBarForSignUp';
import SendAuthCode from '../common/SendAuthCode';
import InputAuthCode from '../common/InputAuthCode';
import InputUserData from '../common/InputUserData';
import Complete from '../common/Complete';
import { PrevPageType } from '../../../../helper/_prevPageType';
import { jumpToTop } from '../../../../helper/_scroll';
import Error from '../../../common/common/Dialog/Error.vue';

const PHASE_LIST = {
  SEND_AUTH_CODE: {
    number: 1,
    text: 'メール送信',
    trace_p: 'SignUpMail',
  },
  INPUT_AUTH_CODE: {
    number: 2,
    text: '認証',
    trace_p: 'SignUpCode',
  },
  INPUT_USER_DATA: {
    number: 3,
    text: '登録情報入力',
    trace_p: 'SignUpInput',
  },
  COMPLETE: {
    number: 4,
    text: '完了',
    trace_p: 'SignUpComp',
  },
};

export default {
  components: {
    ProgressBarForSignUp,
    SendAuthCode,
    InputAuthCode,
    InputUserData,
    Complete,
    Error,
  },
  data() {
    return {
      currentPhase: PHASE_LIST.SEND_AUTH_CODE.number,
      mailAddress: {},
      prevPageType: undefined,
      isOpenMailPermissionFailedDialog: false,
      actionKbn: '',
      hashKey: '',
      errorMessageGetMailAddress: '',
      actionUserInfo: {},
      errorGetMailAddress: false, // アクション入力時のメールアドレス取得エラーフラグ
      csrfToken: '',
      buttonKbn: '',
    };
  },
  computed: {
    PHASE_LIST() {
      return PHASE_LIST;
    },
    isPreviousPageActionComplete() {
      return Boolean(this.actionKbn) && Boolean(this.buttonKbn) && Boolean(this.hashKey);
    },
  },
  watch: {
    // メールアドレスを修正したときに、アクション入力時使用のメールアドレス取得エラーが出ないように監視
    mailAddress(changeMailAddress) {
      if (changeMailAddress) this.errorGetMailAddress = false;
    },
  },
  created() {
    const { previousPageType, buttonKbn, actionKbn, hashKey, csrfToken } = frontend;
    if (frontend) this.prevPageType = new PrevPageType(previousPageType);
    if (buttonKbn && actionKbn && hashKey && csrfToken) {
      this.currentPhase = parseInt(buttonKbn, 10);
      this.actionKbn = actionKbn;
      this.hashKey = hashKey;
      this.csrfToken = csrfToken;
      this.buttonKbn = buttonKbn;
    }
    // アクション完了画面から認証コード入力画面へ遷移した場合、アクション入力時に使用していたメールアドレスを取得する
    if (this.currentPhase === PHASE_LIST.INPUT_AUTH_CODE.number) this.getActionMailAddress();
  },
  methods: {
    changeTraceP(val) {
      window.trace_p = val;
      if (s) {
        s.t();
      }
    },
    gotoInputAuthCode(payload) {
      this.currentPhase = PHASE_LIST.INPUT_AUTH_CODE.number;
      this.changeTraceP(PHASE_LIST.INPUT_AUTH_CODE.trace_p);
      this.mailAddress = payload.mailAddress;
      jumpToTop();
    },
    fixEmail() {
      this.currentPhase = PHASE_LIST.SEND_AUTH_CODE.number;
      this.changeTraceP(PHASE_LIST.SEND_AUTH_CODE.trace_p);
      jumpToTop();
    },
    gotoInputUserData() {
      if (this.actionKbn && this.hashKey) this.getActionUserInfo();
      this.currentPhase = PHASE_LIST.INPUT_USER_DATA.number;
      this.changeTraceP(
        this.prevPageType.isOrganic() ? PHASE_LIST.INPUT_USER_DATA.trace_p : `${PHASE_LIST.INPUT_USER_DATA.trace_p}Act`,
      );
      jumpToTop();
    },
    gotoComplete(payload) {
      this.currentPhase = PHASE_LIST.COMPLETE.number;
      if (s) {
        s.events = s.apl(s.events, 'event24', ',', 1);
      }
      if (payload && payload.error) {
        this.isOpenMailPermissionFailedDialog = true;
      }
      this.changeTraceP(
        this.prevPageType.isOrganic() ? PHASE_LIST.COMPLETE.trace_p : `${PHASE_LIST.COMPLETE.trace_p}Act`,
      );
      jumpToTop();
    },
    closeDialog() {
      this.isOpenMailPermissionFailedDialog = false;
    },
    getActionMailAddress() {
      const params = {
        actionKbn: this.actionKbn,
        hashKey: this.hashKey,
      };
      axios
        .post('/net2/quipMember/register/actionAfterGetMailAddressJson/', qs.stringify(params))
        .then((response) => {
          if (!response) throw error;
          if (!response.data) throw error;
          const { resultCode, emailAccount, emailDomain } = response.data;
          if (resultCode === 0) {
            this.mailAddress = {
              emailAccount,
              emailDomain,
            };
            return;
          }
          throw error;
        })
        .catch((error) => {
          this.errorGetMailAddress = true;
        });
    },
    getActionUserInfo() {
      const param = {
        actionKbn: this.actionKbn,
        hashKey: this.hashKey,
        'org.apache.struts.taglib.html.TOKEN': this.csrfToken,
      };
      axios
        .post('/net2/quipMember/register/actionInfoJson/', qs.stringify(param))
        .then((response) => {
          if (!response) throw error;
          if (!response.data) throw error;
          this.actionUserInfo = response.data;
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.signUp {
  background: #f8f9f9;
  min-height: calc(100vh - #{$height-form-header-pc} - #{$height-form-footer-pc});

  .singUpCard {
    border-radius: 6px;
    margin: 0 auto 40px;
    width: 760px;
    background: #fff;
    border: 1px solid #d3d4d4;
    box-sizing: border-box;
    padding: 32px 0 40px;

    .sendAuthCode {
      width: 552px;
      margin: 0 auto;
    }

    .inputAuthCode {
      width: 360px;
      margin: 0 auto;
    }

    .inputUserData {
      width: 615px;
      margin: 0 auto;
    }

    .complete {
      width: 632px;
      margin: 0 auto;
    }
  }
}
</style>
